/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { iCompetenciasTrabalhadas } from '../..'

interface BarChartProps {
  id: string
  data: iCompetenciasTrabalhadas
}

export const BarChartCompetencias: React.FC<BarChartProps> = ({ id, data }) => {
  function GerarGrafico(): void {
    const options = {
      series: [{
        data: data.qtd
      }],
      chart: {
        type: 'bar',
        height: data.labels.length * 60 > 120 ? data.labels.length * 60 : 120,
        width: 1000
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val.toFixed(0)
          },
          title: {
            formatter: function (val: any) {
              return 'Selecionada:'
            }
          }
        }
      },
      grid: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -20,
        formatter: function (val: string) {
          return parseFloat(val).toFixed(0)
        }
      },
      xaxis: {
        labels: {
          show: false
        },
        categories: data.labels,
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-${id}`} />
  )
}
